<button
    mat-icon-button
    class="riege-button riege-button--icon sidepanel__close md-16"
    aria-label="Close"
    i18n-aria-label="@@button-label-close"
    matDialogClose>
    <mat-icon>close</mat-icon>
</button>

<div class="sidepanel__inner">
    <ng-content></ng-content>
</div>
